<template>
    <div class="form-area col-12 col-lg-auto">
        <report v-if="chartScreenshot" :chart-image="chartScreenshot" />
    </div>

    <div class="data-area col-12 col-lg" ref="dataArea">
        <!-- Modal to edit chart settings -->
        <chart-settings-modal
            :graph-settings-title="$t('chartSettings.groupName.reportSettings')"
            v-model:is-open="isSettingsModalOpen"
            v-model:graph-settings="chartStore.reportSettings"
        />

        <concentration-chart
            :graph-settings="chartStore.reportSettings"
            @open-settings="isSettingsModalOpen = true"
            @chart-controller-loaded="takeChartScreenshot"
        />
    </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import ChartSettingsModal from '@/components/ChartSettingsModal.vue';
import ConcentrationChart from '@/components/ConcentrationChart.vue';
import { useChartsStore } from '@/store/charts';
import Report from './Report.vue';

export default defineComponent({
    components: {
        ChartSettingsModal,
        ConcentrationChart,
        Report,
    },

    setup()
    {
        const chartStore = useChartsStore();
        const dataArea = ref<HTMLElement|null>();
        const chartScreenshot = ref<string|null>();

        const isSettingsModalOpen = ref(false);

        function takeChartScreenshot()
        {
            const canvasElement = dataArea.value?.querySelector("[data-chart-canvas]");

            if (!(canvasElement instanceof HTMLCanvasElement)) {
                return;
            }

            chartScreenshot.value = canvasElement.toDataURL("image/png");
        }

        return {
            chartStore,
            dataArea,
            isSettingsModalOpen,
            chartScreenshot,
            takeChartScreenshot,
        };
    },
});
</script>
